document.getElementById('pincodeForm').addEventListener('submit', function (event) {
    event.preventDefault();

    const pincode = document.getElementById('pincode').value;
    const pincodeInputElement = document.getElementById('pincode');
    const responseDiv = document.getElementById('response');
    const orderTimelineDiv = document.getElementById('order-timeline');
    const infoMessage = document.querySelector('.pincode-info-message');

    const deliverySvg = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
        <path d="M13.332 2.5H0.832031V13.3333H13.332V2.5Z" stroke="#000" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M13.332 6.66699H16.6654L19.1654 9.16699V13.3337H13.332V6.66699Z" stroke="#000" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M4.58333 17.4997C5.73393 17.4997 6.66667 16.5669 6.66667 15.4163C6.66667 14.2657 5.73393 13.333 4.58333 13.333C3.43274 13.333 2.5 14.2657 2.5 15.4163C2.5 16.5669 3.43274 17.4997 4.58333 17.4997Z" stroke="#000" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M15.4154 17.4997C16.566 17.4997 17.4987 16.5669 17.4987 15.4163C17.4987 14.2657 16.566 13.333 15.4154 13.333C14.2648 13.333 13.332 14.2657 13.332 15.4163C13.332 16.5669 14.2648 17.4997 15.4154 17.4997Z" stroke="#000" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>`;

    const changePincodeButton = document.querySelector('.change-pincode-button');
    const submitPincodeButton = document.querySelector('.submit-pincode-button');
    const pincodeResponseContainer = document.querySelector('.pincode-response-container');

    const resetDisplayStyles = () => {
        submitPincodeButton.style.display = "block";
        changePincodeButton.style.display = "none";
        responseDiv.style.display = "none";
        infoMessage.style.display = "flex";
        orderTimelineDiv.style.display = "none";
        pincodeResponseContainer.style.display = "none";
    };

    changePincodeButton.addEventListener("click", resetDisplayStyles);
    pincodeInputElement.addEventListener('keydown', resetDisplayStyles);

    responseDiv.innerText = '';
    responseDiv.style.display = "flex";
    infoMessage.style.display = "none";

    // ---- Pincode validation ----
    if (!/^\d{6}$/.test(pincode)) {
        responseDiv.innerText = 'Please enter a valid pincode!';
        submitPincodeButton.style.display = "none";
        changePincodeButton.style.display = "block";
        pincodeResponseContainer.style.display = "block";
        return;
    }

    const url = 'https://lbp-edd.marmeto.com/api/estimate-delivery-days';
    const requestBody = { destination_pincode: pincode };

    fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(requestBody)
    })
        .then(response => response.json())
        .then(data => {
            console.log('API response:', data);
            if (!data.success) {
                responseDiv.innerText = `${data.message}`;
                submitPincodeButton.style.display = "none";
                changePincodeButton.style.display = "block";
                pincodeResponseContainer.style.display = "block";
                return;
            }

            // ---- Cutoff logic ----
            const now = new Date();
            const cutoffHour = 14; // 2 PM
            const isAfterCutoff = now.getHours() >= cutoffHour;

            const baseTat = data.data.data.tat;
            const effectiveTat = isAfterCutoff ? baseTat + 1 : baseTat;

            // ---- Delivery date ----
            const deliveryDate = new Date();
            deliveryDate.setDate(deliveryDate.getDate() + effectiveTat);

            const formattedDate = deliveryDate.toLocaleDateString('en-US', {
                weekday: 'short',
                month: 'long',
                day: 'numeric'
            });

            responseDiv.innerHTML = `${deliverySvg} Get it by ${formattedDate}`;

            // ---- Timeline messaging ----
           

            // Today at 2:00 PM
            let cutoffTime = new Date();
            cutoffTime.setHours(14, 0, 0, 0);

            // If after today's cutoff, move cutoff to tomorrow 2 PM
            if (isAfterCutoff) {
                cutoffTime.setDate(cutoffTime.getDate() + 1);
            }

            // Time difference
            let diffMs = cutoffTime - now;

            // Safety clamp (shouldn’t be negative, but just in case)
            if (diffMs < 0) diffMs = 0;

            const diffHrs = Math.floor(diffMs / (1000 * 60 * 60));
            const diffMins = Math.floor((diffMs % (1000 * 60 * 60)) / (1000 * 60));

            orderTimelineDiv.innerHTML = `
                If ordered within <strong>${diffHrs} hrs ${diffMins} mins</strong>
            `;


            // ---- UI state ----
            orderTimelineDiv.style.display = "block";
            submitPincodeButton.style.display = "none";
            changePincodeButton.style.display = "block";
            pincodeResponseContainer.style.display = "block";
        })
        .catch(error => {
            responseDiv.innerText = `Error fetching delivery details`;
            console.error(error);
        });
});
